import React, { useState } from 'react'
import useTranslation from '../../shared/TranslationProvider'
import AylaInputForm from './AylaInputForm'
import { Button } from '../../../lib/ui/button'
import { useIntroductionScript } from './IntroductionScriptProvider'
import Scripts from './Scripts'
import { NameDialog } from './NameDialog'
import AylaRatingFeedback from '~/components/shared/AylaRatingFeedback'

export const PageOne = () => {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col">
      <h1>{t('part_1')}</h1>
      <div className="pb-6">{t('intro')}</div>
      <div className="subtitle pb-4">{t('get_started')}</div>
      <AylaInputForm />
    </div>
  )
}

export const PageTwo = () => {
  const {
    currentPage,
    setAylaResponse,
    handlePageChange,
    introductionScriptId,
  } = useIntroductionScript()
  const { t } = useTranslation()
  const { t: tScript } = useTranslation('ayla_response')
  const [typingComplete, setTypingComplete] = useState(false)

  const starDescriptions = tScript('star_ratings', {
    defaultValue: [
      'Missed the Mark',
      'Needs Improvement',
      'Pretty Good',
      'Really Helpful',
      'Exactly What I Needed',
    ],
  })

  const handleClick = () => {
    setAylaResponse(null)
    handlePageChange(1)
  }

  return (
    <div className="flex flex-col gap-4">
      <div>
        <h1>{t('part_2')}</h1>
        <Scripts
          typingComplete={typingComplete}
          setTypingComplete={setTypingComplete}
        />
      </div>
      <div className="flex flex-col self-start">
        <div className="flex flex-col gap-4 md:flex-row">
          <Button
            variant="outline"
            disabled={currentPage === 1}
            onClick={handleClick}
          >
            {t('back')}
          </Button>
          <NameDialog>
            <Button>{t('ayla_response.save')}</Button>
          </NameDialog>
        </div>
      </div>
      {typingComplete && introductionScriptId && (
        <AylaRatingFeedback
          routes={{
            createFeedback: `/job-search/recruiters/introduction_scripts/${introductionScriptId}/feedback`,
          }}
          content={introductionScriptId}
          title={tScript('how_helpful')}
          subtitle={tScript('your_feedback')}
          starDescriptions={starDescriptions}
          className="sm:w-1/2"
        />
      )}
    </div>
  )
}

export const Page = () => {
  const { currentPage } = useIntroductionScript()
  if (currentPage === 1) return <PageOne />
  if (currentPage === 2) return <PageTwo />
}
